import { Blockquote, Amazon } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  React
};